import React, { useEffect, useState } from 'react';
import ScrollResponsiveHeroGraphic from './ScrollResponsiveHeroGraphic';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Scroll-Responsive Hero Graphic */}
      <ScrollResponsiveHeroGraphic />

      {/* Base Background Image (subtle, behind graphic) */}
      <div 
        className="absolute inset-0 w-full h-full opacity-30"
        style={{
          transform: isVisible ? 'scale(1)' : 'scale(1.1)',
          transition: 'transform 1.5s ease-out'
        }}
      >
        <img
          src="https://images.unsplash.com/photo-1631727498532-b27e7f9796ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBtaW5pbWFsfGVufDB8fHxibGFja3wxNzY4ODQzNTY3fDA&ixlib=rb-4.1.0&q=85"
          alt="Abstract technology"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="container mx-auto px-6 md:px-12 lg:px-20 max-w-7xl">
          <div 
            className="max-w-4xl"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
              transition: 'opacity 1s ease-out 0.3s, transform 1s ease-out 0.3s'
            }}
          >
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-6 leading-tight">
              AI-based solutions to real-world problems
            </h1>
            <p 
              className="text-xl md:text-2xl lg:text-3xl font-light text-gray-300 mb-12 max-w-3xl"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'opacity 1s ease-out 0.6s, transform 1s ease-out 0.6s'
              }}
            >
              We design, deploy, and teach AI systems that integrate into real workflows, data, and decision-making.
            </p>
            <button 
              className="text-lg font-medium px-8 py-4 bg-white text-black rounded-full hover:bg-gray-200 transition-all duration-300 hover:scale-105"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'opacity 1s ease-out 0.9s, transform 1s ease-out 0.9s'
              }}
            >
              Start a conversation
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
        style={{
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 1s ease-out 1.2s'
        }}
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;